<template>
  <div v-if="!loading">
    <h1 class="main-header">
      <translate translate-context="event_template" :translate-params="{id: template.id, name: template.name}">Edit template  #%{id} - %{name}</translate>
    </h1>
    <Form :data=template @save="onSave" :save_text="$pgettext('form','Save')"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Form from "@/domain/eventTemplate/components/Form.vue";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";

export default {
  name: 'EditEventTemplate',
  components: {Form},
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await this.fetchTemplate(this.$route.params.id)
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'eventTemplate.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('eventTemplate', [
      'template',
    ]),
  },
  methods: {
    ...mapActions('eventTemplate', [
      'fetchTemplate',
      'updateTemplate',
    ]),
    async onSave(data) {
      await this.updateTemplate({id: this.template.id,data: data})
      await this.$router.push({name: 'eventTemplate.list'})
      throw new SuccessNotification(this.$pgettext('event_template', 'Template updated!'))
    }
  }
}
</script>

<style scoped>

</style>